import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/contexts/AuthContext";
import { supabase } from "@/integrations/supabase/client";

export interface InterstitialStatus {
  is_pre_seeded: boolean;
  interstitial_completed_at: string | null;
}

export const useInterstitialStatus = () => {
  const { user } = useAuth();
  return useQuery({
    queryKey: ["interstitial-status", user?.id],
    queryFn: async (): Promise<InterstitialStatus | null> => {
      if (!user) return null;
      const { data, error } = await supabase
        .from("profiles")
        .select("is_pre_seeded, interstitial_completed_at")
        .eq("id", user.id)
        .maybeSingle();
      if (error) throw error;
      return data;
    },
    enabled: !!user,
    staleTime: 60_000,
  });
};

export const isGatedByInterstitial = (
  s: InterstitialStatus | null | undefined,
): boolean => s?.is_pre_seeded === true && s.interstitial_completed_at === null;
